// import { useTranslation } from 'react-i18next'

export const Language = () => {
  
  // const { i18n:{language} } = useTranslation()
  
  return null


}